import { Component, Input, OnInit } from '@angular/core';
import { InteractBannerInfo } from '@app/home/models/interact-banner-info.model';
import { HomeService } from '@app/home/services/home.service';
import { FACET_VALUE } from '@app/new-search/constants/new-search-constants';
import { PlatformService } from '@panamax/app-state';
import { PATHS } from '@shared/constants/paths';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { UpcService } from '@shared/services/upc/upc.service';

@Component({
  selector: 'app-interact-banner',
  templateUrl: './interact-banner.component.html',
  styleUrls: ['./interact-banner.component.scss'],
})
export class InteractBannerComponent implements OnInit {
  @Input() interactBannerInfo?: InteractBannerInfo;
  @Input() isNewSearchEnabled = false;
  bannerUrl: string;
  bannerClass: string;
  clickable = false;

  constructor(
    readonly navigationHelperService: NavigationHelperService,
    readonly platformService: PlatformService,
    private upcService: UpcService,
    private homeService: HomeService,
  ) {}

  ngOnInit() {
    const browserDimensions = this.platformService.getBrowserDimensions();
    if (browserDimensions && browserDimensions.width) {
      if (browserDimensions.width >= 1280) {
        this.bannerUrl = this.interactBannerInfo?.largeImageUrl;
        this.bannerClass = 'largeBanner';
      } else if (
        browserDimensions.width >= 1024 &&
        browserDimensions.width < 1280
      ) {
        this.bannerUrl = this.interactBannerInfo?.mediumImageUrl;
        this.bannerClass = 'mediumBanner';
      } else if (
        browserDimensions.width >= 450 &&
        browserDimensions.width < 1024
      ) {
        this.bannerUrl = this.interactBannerInfo?.smallImageUrl;
        this.bannerClass = 'smallBanner';
      } else {
        this.bannerUrl = this.interactBannerInfo?.mobileImageUrl;
        this.bannerClass = 'mobileBanner';
      }
    }
    if (
      this.interactBannerInfo?.offerType === 'Product Detail' ||
      this.interactBannerInfo?.offerType === 'Search' ||
      this.interactBannerInfo?.offerType === 'Product Promotions' ||
      this.interactBannerInfo?.offerType === 'Preference Center' ||
      this.interactBannerInfo?.offerType === 'GeneralDefault' ||
      this.interactBannerInfo?.offerType === 'GeneralScoopDefault' ||
      (this.interactBannerInfo?.clickThroughUrl &&
        this.interactBannerInfo?.clickThroughUrl !== '')
    ) {
      this.clickable = true;
    }
  }

  bannerClicked() {
    const trackBannerId = this.interactBannerInfo?.mediumImageUrl?.substring(
      this.interactBannerInfo?.mediumImageUrl
        ?.toLowerCase()
        ?.indexOf('interact/'),
    );
    let trackBannerUrl = null;
    if (this.interactBannerInfo?.offerType === 'Product Detail') {
      if (
        this.interactBannerInfo?.searchProduct &&
        this.interactBannerInfo?.searchProduct !== ''
      ) {
        this.homeService.trackInteractBannerClick(
          trackBannerId,
          trackBannerUrl,
        );
        this.navigationHelperService.routeToProductDetails(
          +this.interactBannerInfo?.searchProduct,
        );
      }
    } else if (this.interactBannerInfo?.offerType === 'Search') {
      if (
        this.interactBannerInfo?.searchProduct &&
        this.interactBannerInfo?.searchProduct !== ''
      ) {
        this.homeService.trackInteractBannerClick(
          trackBannerId,
          trackBannerUrl,
        );
        this.navigationHelperService.routeToSearch({
          searchText: this.interactBannerInfo?.searchProduct,
        });
      }
    } else if (this.interactBannerInfo?.offerType === 'Product Promotions') {
      this.homeService.trackInteractBannerClick(trackBannerId, trackBannerUrl);
      this.navigationHelperService.routeTo(PATHS.DEALS + '/' + PATHS.ALL_DEALS);
    } else if (this.interactBannerInfo?.offerType === 'Preference Center') {
      this.homeService.trackInteractBannerClick(trackBannerId, trackBannerUrl);
      this.upcService.openUPC();
    } else if (this.interactBannerInfo?.offerType === 'NonEcomm CTA') {
      if (
        this.interactBannerInfo?.clickThroughUrl &&
        this.interactBannerInfo?.clickThroughUrl !== ''
      ) {
        trackBannerUrl = this.interactBannerInfo?.clickThroughUrl;
        this.homeService.trackInteractBannerClick(
          trackBannerId,
          trackBannerUrl,
        );
        window.open(this.interactBannerInfo?.clickThroughUrl);
      }
    } else if (this.interactBannerInfo?.offerType === 'GeneralDefault') {
      if (
        this.interactBannerInfo?.clickThroughUrl &&
        this.interactBannerInfo?.clickThroughUrl !== ''
      ) {
        trackBannerUrl = this.interactBannerInfo?.clickThroughUrl;
        this.homeService.trackInteractBannerClick(
          trackBannerId,
          trackBannerUrl,
        );
        window.open(this.interactBannerInfo?.clickThroughUrl);
      }
    } else if (this.interactBannerInfo?.offerType === 'GeneralScoopDefault') {
      this.homeService.trackInteractBannerClick(trackBannerId, trackBannerUrl);
      if (this.isNewSearchEnabled) {
        this.navigationHelperService.routeToNewSearch({
          facetFilters: `our_exclusives:${FACET_VALUE.ALL_SCOOP}`,
        });
      } else {
        this.navigationHelperService.routeToSearch({
          searchText: 'allscoopproducts',
        });
      }
    }
  }
}
